export const EXPERIMENT_USA_UNLIMITED_OFFER = 'usa-unlimited-offer';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_CONTROL = 'control';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_ONLY =
  'unlim-only';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_PLUS =
  'unlim-19-plus-12';
export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_INBOX = 'inbox-received-transfers';
export const EXPERIMENT_SEND_FEEDBACK = 'send-feedback';
export const EXPERIMENT_FU_ACCESSIBILITY = 'folder-upload-accessibility';
export const EXPERIMENT_VIDEO_UPLOADS = 'video-wallpaper-uploads';
export const EXPERIMENT_TRANSFER_OPTIONS_ICON = 'transfer-options-icon';
export const EXPERIMENT_SPLASHPAGE_REDESIGN = 'splashpage-redesign';
export const EXPERIMENT_SPLASHPAGE_FAKE_DOOR = 'splashpage-fake-door';
export const EXPERIMENT_FREE_ACCOUNT = 'free-account';
export const EXPERIMENT_CANCELLATION_COPY = 'cancellation-copy';
export const EXPERIMENT_RECEIVING_PAGE = 'receiving-page';

export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';
export const FF_PIXEL_TRACKING = 'marketing-pixel-tracking';

export const EXPERIMENT_RECEIVING_VARIANT_LARGE_HEADER = 'large-header';
export const EXPERIMENT_RECEIVING_VARIANT_STICKY_APP_BAR = 'sticky-app-bar';
export const EXPERIMENT_RECEIVING_VARIANT_APP_BAR = 'app-bar';
